import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sce',
  templateUrl: './sce.component.html',
  styleUrls: ['./sce.component.scss']
})
export class SceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

